import breakpoints from "shared/utils/breakpoints";
import styled from "styled-components";

type modalPropT = {
  visibile: boolean;
};

type mainModalPropT = {
  width?: string;
  marginTop?: string;
};

export const ModalContainer = styled.div<modalPropT>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(9, 30, 66, 0.54);
  z-index: 999;
  display: ${(prop) => (prop.visibile ? "block" : "none")};
  overflow-y: auto;
`;

export const ModalMain = styled.div<mainModalPropT>`
  width: ${(prop) => (prop.width ? prop.width : "35%")};
  margin: auto;
  margin-top: ${(prop) => (prop.marginTop ? prop.marginTop : "8rem")};
  padding: 0.5rem;

  @media ${breakpoints.device.max.xs} {
    width: 85%;
    margin-top: 0px;
  }
`;

export const ModalMainHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  margin-bottom: 1rem;
`;

export const ModalContent = styled.div`
  width: 98%;
  padding: 2rem 0.4rem 0.4rem 0.4rem;
  border-radius: 0.8rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ModalCloseBtn = styled.div`
  position: relative;
  width: 1.8rem;
  height: 1.8rem;
  margin-right: -1rem;
  top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 50rem;
  position: relative;
  transition: all ease 0.4s;
  cursor: pointer;
  &:hover {
    top: 0.4rem;
  }
`;

export const CloseSpan = styled.span`
  display: block;
  background-color: #333;
  width: 1.2rem;
  height: 0.2rem;
  position: absolute;
  transform: rotate(45deg);

  &::before {
    display: block;
    background-color: #333;
    width: 1.2rem;
    height: 0.2rem;
    content: "";
    transform: rotate(-85deg);
  }
`;
